<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 48 48">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.8418 4C23.7417 4 21.2052 6.52042 21.2052 9.60093C21.2052 12.6814 23.7417 15.1552 26.8418 15.1552C29.9419 15.1552 32.4314 12.6348 32.4314 9.60093C32.4314 6.5671 29.8949 4 26.8418 4ZM13.8776 9.22754C12.7033 9.22754 11.529 9.69428 10.6366 10.6278C8.8047 12.4481 8.8047 15.4819 10.6366 17.3022C12.4685 19.1225 15.5216 19.1225 17.3535 17.3022C19.1854 15.4819 19.1854 12.4481 17.3535 10.6278C16.4141 9.69428 15.1459 9.22754 13.8776 9.27421V9.22754ZM36.5649 12.8215C36.2831 12.8215 36.0012 12.9615 35.8133 13.1482C35.3906 13.5683 35.3906 14.3151 35.8133 14.7351C36.2361 15.1552 36.9876 15.1552 37.4104 14.7351C37.8331 14.3151 37.8331 13.5683 37.4104 13.1482C37.1755 12.9148 36.8937 12.8215 36.5649 12.8215ZM9.32138 20.8961C6.97281 20.8961 5 22.8565 5 25.1902C5 27.5239 6.92583 29.4842 9.32138 29.4842C11.7169 29.4842 13.6428 27.5706 13.6428 25.1902C13.6428 22.8098 11.67 20.8961 9.32138 20.8961ZM41.2621 23.4632C40.3226 23.4632 39.5241 24.2567 39.5241 25.1902C39.5241 26.1237 40.3226 26.9172 41.2621 26.9172C42.2015 26.9172 43 26.1237 43 25.1902C43 24.2567 42.2015 23.4632 41.2621 23.4632ZM13.9716 32.6581C12.9852 32.6581 11.9988 33.0315 11.2942 33.7316C9.83807 35.1785 9.83807 37.6056 11.2942 39.0525C12.7503 40.4994 15.1928 40.4994 16.6489 39.0525C18.1051 37.6056 18.1051 35.1785 16.6489 33.7316C15.8974 32.9848 14.958 32.6581 13.9716 32.6581ZM36.5179 34.245C35.9543 34.245 35.4376 34.4784 35.0148 34.8985C34.1693 35.7386 34.1693 37.1389 35.0148 37.979C35.8603 38.8191 37.2695 38.8191 38.115 37.979C38.9604 37.1389 38.9604 35.7386 38.115 34.8985C37.6922 34.4784 37.0816 34.245 36.5179 34.245ZM25.1978 38.119C23.6007 38.119 22.2855 39.4726 22.2855 41.0595C22.2855 42.6464 23.6477 44 25.2447 44C26.8418 44 28.204 42.6464 28.204 41.0595C28.204 39.4726 26.8888 38.119 25.2447 38.119C25.2447 38.119 25.1978 38.119 25.1508 38.119H25.1978Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
